<div class="assistant-sub-header">
  {{ assistantContent.preferences }}
</div>
<div class="assistant-bullets" data-cy="assistant-bullets" *ngIf="teamsProperties">
  <div class="bullet" *ngFor="let bullet of bulletsContent">
    <div class="title">
      <span>{{ bullet.description }}</span>
      <u-icon
        *ngIf="bullet.displayInfoIcon"
        [model]="{ type: 'font', value: 'icon-info' }"
        [styles]="{ color: 'var(--color-primary)', fontSize: '14px' }"
        [pTooltip]="bullet.infoTooltip"
        class="bullet-title-info-icon"
        tooltipPosition="top"
        tooltipStyleClass="u-tooltip"
      ></u-icon>
    </div>
    <div class="bullet-actions-container">
      <ng-container *ngTemplateOutlet="bulletAdvancedAction; context: { bullet }"></ng-container>
      <u-toggle-switch
        [disabled]="viewOnly"
        [checked]="assistantBullets[bullet.type]"
        debounceClick
        type="small"
        (onChange)="onUpdateSync($event, bullet.type)"
      ></u-toggle-switch>
    </div>
  </div>
</div>

<ng-template #bulletAdvancedAction let-bullet="bullet">
  <div class="bullet-advanced-action" *ngIf="assistantBullets?.[bullet.type]">
    <span *ngIf="bullet.actionInfo?.preText">{{ bullet.actionInfo.preText }}</span>
    <ng-container [ngSwitch]="bullet.type">
      <ng-container *ngSwitchCase="'enableRelatedArticles'">
        <u-input-number
          [maxValue]="LIMIT_RELATED_ARTICLES_MAX"
          [minValue]="LIMIT_RELATED_ARTICLES_MIN"
          [styles]="{ width: '28px', height: '28px' }"
          [inputModel]="knowledgeResourcesLimit"
          [disabled]="viewOnly"
          [resetToMaxOnClickOut]="true"
          (onChange)="changeRelatedArticlesLimit($event)"
        >
        </u-input-number>
      </ng-container>
    </ng-container>
    <span *ngIf="bullet.actionInfo?.postText">{{ bullet.actionInfo.postText }}</span>
  </div>
</ng-template>
